<button
  class="btn btn-rounded btn-rounded-square add-field-btn"
  type="button"
  [matMenuTriggerFor]="selectFieldTypeMenu"
>
  <craft-icon class="svg-icon text-size-12" name="general--plus-sm"></craft-icon>
  <span class="ml-10">Add Field</span>
</button>

<mat-menu #selectFieldTypeMenu="matMenu" class="idea-details-menu">
  <ng-template matMenuContent="">
    <button *ngFor="let item of list" type="button" mat-menu-item="" (click)="showAddDialog(item)">
      {{ item.label }}
    </button>
    <ng-container *ngIf="!hideGuruItems">
      <mat-divider></mat-divider>
      <button
        type="button"
        class="mat-mdc-menu-item"
        [matMenuTriggerFor]="presetsMenu"
        (click)="$event.stopPropagation()"
      >
        <craft-icon class="svg-icon guru-icon" name="guru--guru-op-4"></craft-icon>
        Guru Questions
      </button>
    </ng-container>
  </ng-template>
</mat-menu>

<mat-menu #presetsMenu="matMenu" class="presets-sub-menu">
  <ng-template matMenuContent="">
    <craft-custom-presets-menu (select)="selectPreset($event)" [showTypes]="true"></craft-custom-presets-menu>
  </ng-template>
</mat-menu>
